module.exports = __webpack_public_path__ + "static/img/line-bnr.070ad4e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/line-bnr.jpeg
// module id = tbj0
// module chunks = 0